import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavContext } from 'Context/NavContext';

export const WithUnknownPageCollectionType = (props) => {
  const { setPageCollectionType } = useNavContext();

  useEffect(() => {
    setPageCollectionType(null);
  }, [setPageCollectionType]);
  const { Component, ...rest } = props;

  return <Component {...rest} />;
};

WithUnknownPageCollectionType.propTypes = {
  Component: PropTypes.element.isRequired,
};

export const withUnknownPageCollectionType = (Component) => {
  return (props) => <WithUnknownPageCollectionType Component={Component} {...props} />;
};
